<template>
    <div>
        <rkm-area
            no-margin-top
            title="Identificação do paciente"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :value="data.form.paciente.nome"
                        disabled
                        label="Nome"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="data.form.paciente.nomeSocial"
                        disabled
                        label="Nome social"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="data.form.paciente.dataNascimento"
                        disabled
                        label="Data de nascimento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="data.form.paciente.idade"
                        disabled
                        label="Idade"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :value="data.form.paciente.nomeMae"
                        disabled
                        label="Nome da mãe"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="data.form.paciente.prontuario"
                        disabled
                        label="Prontuário municipal"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :danger="!cpfValid"
                        :validations="validations.cpf"
                        label="CPF"
                        v-mask="mask.cpf"
                        v-model="data.form.paciente.cpf"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :danger="!cnsValid"
                        :validations="validations.cns"
                        label="CNS"
                        v-mask="mask.cns"
                        v-model="data.form.paciente.cns"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :danger="!telefoneValid"
                        :validations="validations.telefone"
                        label="Telefone"
                        v-mask="data.form.paciente.telefoneNumero && data.form.paciente.telefoneNumero.length < 15 ? mask.phone : mask.cellPhone"
                        v-model="data.form.paciente.telefoneNumero"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :value="data.form.paciente.municipioUf"
                        disabled
                        label="Município / Estado"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="data.form.paciente.unidadeReferencia"
                        disabled
                        label="Unidade de referência"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import {mask} from '@/mixins'

// Utils.
import cns from '@/utils/validations/cns'
import cpf from '@/utils/validations/cpf'

export default {
    computed: {
        validations() {

            return {
                cns: {
                    required: true,
                    min_max_without_mask: 15,
                    cns: true,
                },
                cpf: {
                    required: true,
                    min_max_without_mask: 11,
                    cpf: true
                },
                telefone: {
                    required: true,
                    min_max_without_mask: [10, 11]
                }
            }
        },
        cnsValid (){
            return this.validationsUtil.cns(this.data.form.paciente.cns)
        },
        cpfValid() {
            return this.validationsUtil.cpf(this.data.form.paciente.cpf)
        },
        telefoneValid() {
            return this.data.form.paciente.telefoneNumero
                && (this.data.form.paciente.telefoneNumero.length == 14 || this.data.form.paciente.telefoneNumero.length == 15)
        },
    },
    data: () => ({
        validationsUtil: { cns, cpf },
    }),
    mixins: [mask],
    props: {
        data: {type: Object, required: true},
    },
}
</script>